<template>
  <road-book-edit
    ref="roadBookEdit"
    pageType="update"
    :id="id"
  ></road-book-edit>
</template>
<script>
import roadBookEdit from "./components/editRoadBook";
export default {
  name: "updateRoadBooks",
  components: { roadBookEdit },
  data() {
    return {
      id: this.$route.query.id
    };
  },
  activated() {
    if (this.$route.params.refresh) {
      this.id = this.$route.query.id;
      this.$refs.roadBookEdit.refreshData();
    }
  }
};
</script>
